
export default class Utitl{
	static getUrlKey(name,url){
		var search = name + "=";
		var index = url.indexOf(search);
		var length =url.length - index;
		var start = index+search.length;
		var value = url.substring(start);
		var items = value.split("&");
		var value = items[0];
		
		return value;
	}
	
	static getTimeString(time){
		let hour = parseInt(time / 3600);
		let minTime = time - 3600*hour;
		let min = parseInt(minTime / 60);
		let secondTime = minTime - 60*min;
		let second = parseInt(secondTime);
		let hourString = '';
		let minString = '';
		let secondString = '';
		if (hour >= 0 && hour <= 9) {
			hourString = "0" + hour;
		}
		else if (hour > 9) {
			hourString = '' + hour;
		}
		if (min >= 0 && min <= 9) {
			minString = "0" + min;
		}
		else if (min > 9) {
			minString = '' + min;
		}
		else {
			minString = '00';
		}
		if (second >= 0 && second <= 9) {
			secondString = "0" + second;
		}
		else if (second > 9) {
			secondString = '' + second;
		}
		let timeString = '';
		if (hourString != '' && hour > 0) {
			timeString += hourString + ':';
		}
		if (minString != '') {
			timeString += minString + ':';
		}
		if (secondString != '') {
			timeString += secondString;
		}
	
		return timeString;
	}
}